/**
 * @file crm-deal-create.ts
 * @description Проверка формы «Новая сделка» (phase19.31, зона «Клиенты и
 * сделки»): название, клиент, воронка и необязательная сумма.
 *
 * Чистая функция: форма показывает ошибки под полями, а в сервер уходит уже
 * собранный `CreateDealPayload` (сумма — строкой с точкой, как ждёт сервер).
 */

import type { CreateDealPayload } from "./api-crm";

export interface DealDraft {
  displayName: string;
  customerId: string;
  pipelineId: string;
  /** Сумма как введена: «7 500», «7500,50»; пусто — без суммы. */
  amount: string;
}

export type DealDraftErrors = Partial<Record<keyof DealDraft, string>>;

/** «7 500,50» → «7500.50»; мусор — `null`. */
export function parseAmountInput(raw: string): string | null {
  // `\s` в JS покрывает и неразрывный пробел из «7 500».
  const value = raw.replace(/[\s₽]/g, "").replace(",", ".");
  if (!/^\d+(\.\d{1,2})?$/.test(value)) return null;
  return value;
}

export function validateDealDraft(draft: DealDraft): { errors: DealDraftErrors; payload: CreateDealPayload | null } {
  const errors: DealDraftErrors = {};
  const name = draft.displayName.trim();
  if (!name) errors.displayName = "Назовите сделку: что и для кого";
  if (!draft.customerId) errors.customerId = "Выберите клиента";
  if (!draft.pipelineId) errors.pipelineId = "Выберите воронку";
  const amount = draft.amount.trim() ? parseAmountInput(draft.amount) : undefined;
  if (amount === null) errors.amount = "Сумма — число, например 7 500 или 7 500,50";
  if (Object.keys(errors).length > 0) return { errors, payload: null };
  return {
    errors,
    payload: {
      displayName: name,
      customerId: draft.customerId,
      pipelineId: draft.pipelineId,
      expectedAmountGross: amount ?? undefined,
    },
  };
}
